import { FeatureDetails } from "components/FeatureDetails/FeatureDetails";
import {
  LockDescription,
  ModalDescriptionWrapper,
} from "../RevenueMetrics/RevenueMetricsLocked";
import { LockFeatures } from "../RevenueMetrics/RevenueMetricsLocked";
import BannerMyProduct from "static/images/MyProducts.png";
import { Button } from "components/DesignSystem/Button/Button";
import { BooksSoftwareSubscriptionsModal } from "components/BooksSoftwareSubscriptionsModal";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useModal } from "hooks/useModal";

export const LockMyProducts = () => {
  const entityId = useCurrentEntityId();
  const subscriptionModal = useModal();
  const featureDetails = [
    {
      type: "boxes",
      description: "Easily manage all your products in one place",
    },
    {
      type: "divider",
      description: "",
    },
    {
      type: "reciept",
      description: "Auto-fill product details in tax-ready invoices.",
    },
    {
      type: "divider",
      description: "",
    },
    {
      type: "dashboard",
      description: "Get clear, categorized insights into product revenue",
    },
  ];
  const descriptionText =
    "Manage all your products in one place with auto-filled, tax-ready invoices and clear insights into your revenue";
  return (
    <section className="t-flex t-justify-center t-items-center t-h-full t-w-full">
      <FeatureDetails
        banner={
          <img
            className="t-w-[22.5625rem] t-h-[13.5rem] t-object-cover"
            src={BannerMyProduct}
            alt="My Products"
          />
        }
        description={
          <LockDescription
            descriptionText={descriptionText}
            title="My Products"
          />
        }
        feature={
          <div className="t-flex t-gap-5 t-w-[31.8125rem] sm:t-w-full sm:t-flex-col sm:t-gap-4 sm:t-max-h-none sm:t-h-auto t-h-[80px] t-mx-auto t-items-center">
            {featureDetails.map((feature, index) => (
              <LockFeatures
                key={index}
                type={feature.type}
                description={feature.description}
              />
            ))}
          </div>
        }
        button={
          <Button
            onClick={() => subscriptionModal.open()}
            customType="primary"
            size="regular"
          >
            Upgrade to Inkle Books Standard
          </Button>
        }
      />
      <BooksSoftwareSubscriptionsModal
        open={subscriptionModal.isOpen}
        onClose={() => subscriptionModal.close()}
        entityId={entityId}
        onProductSubscribe={() => subscriptionModal.close()}
        modalDescription={
          <ModalDescriptionWrapper value="Unlock My Products and more with Books Standard Plan" />
        }
      />
    </section>
  );
};
